import React from 'react'
import Formsy from 'formsy-react'
import createReactClass from 'create-react-class'

const Input = createReactClass({
	getInitialState() {
		const { value } = this.props
		return {
			value: value
		}
	},
	// Add the Formsy Mixin
	mixins: [Formsy.Mixin],

	// setValue() will set the value of the component, which in
	// turn will validate it and the rest of the form
	changeValue(event) {
		let value = event.currentTarget.value
		this.setValue(event.currentTarget[this.props.type === 'checkbox' ? 'checked' : 'value'])
	},
	render() {

		// Set a specific className based on the validation
		// state of this component. showRequired() is true
		// when the value is empty and the required prop is
		// passed to the input. showError() is true when the
		// value typed is invalid
		const className = `form-group ${  this.props.className || ' '
		}${this.showRequired() ? 'required' : this.showError() ? 'error' : ''}`

		// An error message is returned ONLY if the component is invalid
		// or the server has returned an error message
		const errorMessage = this.getErrorMessage()
		let title = this.props.title
		let helpInfo = this.props.helpInfo

		return (
			<div className={className}>
				{ title ? <label htmlFor={this.props.name} className="bv-form-label">{ title }
					{ helpInfo && <span className="tooltip">
						<img src={this.props.helpInfoIcon || '/assets/help.svg'} className="tooltip__trigger" alt="" />
						<div className="tooltip__body">{helpInfo}</div>
					</span>	}
				</label> : <label htmlFor={this.props.name} className="bv-form-label">&nbsp;</label> }
				<input
					type={this.props.type || 'text'}
					name={this.props.name}
					onChange={this.changeValue}
					value={this.getValue() || ""}
					className="bv-form-element"
					placeholder={this.props.placeholder}
					style={this.props.style}
					required={this.props.required}
					checked={this.props.type === 'checkbox' && this.getValue() ? 'checked' : null}
					autoComplete="new-password"
					disabled={this.props.disabled}
				/>
				<input type={this.props.type || 'text'} style={{display: "none"}} name={`fake-${  this.props.name}`} />
				<span className='validation-error'>{errorMessage}</span>
			</div>
		)
	}
})

export default Input
